import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Popover,
  Row,
  Select,
  Switch,
  Typography,
  Space,
} from 'antd';
import {
  CreateIndexFund,
  createIndexFund,
  createUnderlyingAsset,
  instrumentTypes,
  marketHours,
  RefreshAssetEod,
  refreshAssetEodFromRefinitiv,
  RefreshIndexFund,
  refreshIndexFundDataFromRefinitiv,
  REGIONS,
  selectors,
  UnderlyingAsset,
} from 'state';
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleOutlined } from '@ant-design/icons';
import { API_URL } from 'settings';

type Props = {
  hide: () => void;
};
const ClientProfileModal: React.FC<Props> = ({ hide }) => {
  const dispatch = useDispatch();

  return (
    <Modal
      open={true}
      // onOk={form.submit}
      onCancel={hide}
      title={'Client Profile'}
      // footer={[{}]}
      width={600}
      footer={null}
    >
      -
      <br />
      -
      <br />
      -
      <br />
      -
      <br />
      -
      <br />
    </Modal>
  );
};
export default ClientProfileModal;
